import Hls from 'hls.js';
import { useEffect } from 'react';

export const useProvideHls = () => {
  useEffect(() => {
    if (!window.Hls) {
      window.Hls = Hls;
    }
  }, []);
};

export default useProvideHls;
